// extracted by mini-css-extract-plugin
export var footer = "Footer-module--footer--1LEZJ";
export var stripe = "Footer-module--stripe--10J_y";
export var inner = "Footer-module--inner--X2wAA";
export var logos = "Footer-module--logos--3FJeg";
export var disclaimer = "Footer-module--disclaimer--O0XGU";